/**
 * Generate email template for corporate subscription request
 * @param {Object} request - Corporate request object
 * @param {string} request.company_name - Company name
 * @param {string} request.contact_name - Contact person name
 * @returns {Object} Email template with subject and body
 */
export function generateCorporateRequestEmail(request) {
    return {
        subject: `GameArtKit Corporate Subscription - ${request.company_name}`,
        body: `Hi ${request.contact_name},\n\nThank you for your interest in GameArtKit's corporate subscription for ${request.company_name}.\n\nBest regards,\nGameArtKit Team`,
    };
}
